import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { RtUICommonModule } from '../common/common.module';
import { RtUIDialogModule } from '../dialog/dialog.module';
import { RtUIPdfViewerModule } from '../pdf-viewer/pdf-viewer.module';
import { BulkSelectModule } from './bulk-select/bulk-select.module';
import { BulkSelectionMessagesModule } from './bulk-selection-messages/bulk-selection.messages.module';
import { CheckboxModule } from './checkbox/checkbox.module';
import { DatePickerModule } from './date-picker/date-picker.module';
import { EmailsInputModule } from './emails-input/emails-input.module';
import { AttachmentItemModule } from './file-upload/attachment-item/attachment-item.module';
import { AttachmentPreviewDialogModule } from './file-upload/attachment-preview-dialog/attachment-preview-dialog.module';
import { FileUploadModule } from './file-upload/file-upload/file-upload.module';
import { FormErrorModule } from './form-error/form-error.module';
import { FormFieldModule } from './form-field/form-field.module';
import { InputModule } from './input/input.module';
import { MaskedInputModule } from './masked-input/masked-input.module';
import { MentionsInputModule } from './mentions-input/mentions-input.module';
import { ProtectedControlsModule } from './protected-controls/protected-controls.module';
import { PROTECTED_CONTROLS_PROVIDERS } from './protected-controls/public_api';
import { RadioFormGroupModule } from './radio-form-group/radio-form-group.module';
import { RadioModule } from './radio/radio.module';
import { RangeSelectionInputModule } from './range-selection-input/range-selection-input.module';
import { SelectDropdownModule } from './select/select-dropdown/select-dropdown.module';
import { SelectModule } from './select/select.module';
import { TaggerModule } from './tagger/tagger.module';
import { TextareaModule } from './textarea/textarea.module';
import { TimePickerDropdownModule } from './time-picker/time-picker-dropdown/time-picker-dropdown.module';
import { TimePickerModule } from './time-picker/time-picker.module';
import { TimeZonePickerDropdownModule } from './time-zone-picker/time-zone-picker-dropdown/time-zone-picker-dropdown.module';
import { TimeZonePickerModule } from './time-zone-picker/time-zone-picker.module';
import { TypeaheadModule } from './typeahead/typeahead.module';

const COMPONENT_MODULES = [
  CheckboxModule,
  InputModule,
  BulkSelectionMessagesModule,
  BulkSelectModule,
  DatePickerModule,
  EmailsInputModule,
  TaggerModule,
  TypeaheadModule,
  AttachmentItemModule,
  AttachmentPreviewDialogModule,
  FileUploadModule,
  FormFieldModule,
  MaskedInputModule,
  ProtectedControlsModule,
  MentionsInputModule,
  RadioModule,
  RadioFormGroupModule,
  RangeSelectionInputModule,
  SelectModule,
  SelectDropdownModule,
  TextareaModule,
  TimePickerDropdownModule,
  TimePickerModule,
  TimeZonePickerModule,
  TimeZonePickerDropdownModule,
  FormErrorModule,
];

@NgModule({
  imports: [
    ReactiveFormsModule,
    FormsModule,
    RtUICommonModule,
    RtUIDialogModule,
    RtUIPdfViewerModule,
    ...COMPONENT_MODULES,
  ],
  exports: [ReactiveFormsModule, FormsModule, ...COMPONENT_MODULES],
})
export class RtUIFormsModule {
  public static forRoot(): ModuleWithProviders<RtUIFormsModule> {
    return {
      ngModule: RtUIFormsModule,
      providers: [...PROTECTED_CONTROLS_PROVIDERS],
    };
  }
}
